import {
  type PdfPageBaseLayout,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@skailer-com/uikit";
import {
  getFieldDisplayLabel,
  getFieldPositionStyle,
  getRoleBoxClass,
  getSignerTitle,
  isFieldRequiredMarkVisible,
} from "@/pages/esign/esign.config.ts";
import { ApiEsignMarkupField, ApiEsignMarkupRole } from "@/types/esign.types.ts";
import { useTranslation } from "react-i18next";

interface EsignPreviewFieldEntry {
  role: ApiEsignMarkupRole;
  roleIndex: number;
  field: ApiEsignMarkupField;
}

export interface EsignPreviewFieldsLayerProps {
  baseLayout: PdfPageBaseLayout;
  entries: EsignPreviewFieldEntry[];
}

export function EsignPreviewFieldsLayer({ baseLayout, entries }: EsignPreviewFieldsLayerProps) {
  const { t } = useTranslation();

  return (
    <div className={"pointer-events-none absolute inset-0"}>
      {entries.map(({ role, roleIndex, field }, index) => (
        <Tooltip delay={false} key={`${roleIndex}-${index}`}>
          <TooltipTrigger asChild={true}>
            <div
              tabIndex={0}
              className={`pointer-events-auto absolute flex items-center justify-center rounded border-2 ${getRoleBoxClass(roleIndex)}`}
              style={getFieldPositionStyle(field, baseLayout.width, baseLayout.height)}
            >
              <span className={"title-sub-headline truncate px-1 text-[10px] leading-none"}>
                {getFieldDisplayLabel(field, t)}
                {isFieldRequiredMarkVisible(field) && <span className={"align-super"}>*</span>}
              </span>
            </div>
          </TooltipTrigger>
          <TooltipContent>{getSignerTitle(role, t)}</TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
